export default __webpack_public_path__ + "static/timeline-a6397c8a5de6025b052c77c9e9400a31.svg";